import React from 'react';
import {
    COVER_DIM_ON_LIGHT,
    CoverLogo,
    CoverMeta,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

export const ModernBand: React.FC<CoverTemplateProps> = ({ fields, colors, logoUrl, showLogo }) => (
    <div className="flex size-full">
        <div className="w-[2.6em] flex-none" style={{ backgroundColor: colors.primary }} />
        <div className="flex flex-1 flex-col justify-between px-[2.2em] py-[3em]">
            <CoverLogo logoUrl={logoUrl} showLogo={showLogo} />
            <div className="flex flex-col gap-[0.6em]">
                <div
                    className="font-bold leading-[1.05] tracking-[-0.02em]"
                    style={{ color: colors.primary, fontSize: coverTitleSize(2.1) }}
                >
                    {fields.document_title}
                </div>
                {fields.subtitle ? (
                    <div className="text-[0.82em]" style={{ color: COVER_DIM_ON_LIGHT }}>
                        {fields.subtitle}
                    </div>
                ) : null}
            </div>
            <CoverMeta fields={fields} />
        </div>
    </div>
);
